import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DoxExplorerTitleSortBar from './doxExplorerTitleSortBar'
import 'react-toastify/dist/ReactToastify.css'
import DoxExplorerTaxYearsTable from './doxExplorerTaxYearsTable'


const DoxExplorerMainTaxYears = (props) => {
    const { ticket, layoutType, onSetTaxYear } = props;
    const taxYear = 0

    const handleSetTaxYear = (tax_year) => {
        onSetTaxYear(tax_year)
    }    

    return (
        <div className={classnames('doxe-container', layoutType)}>
            <DoxExplorerTitleSortBar tax_year={taxYear}
                onBackToRoot={onSetTaxYear} layoutType={layoutType} />
            <DoxExplorerTaxYearsTable onSetTaxYear={handleSetTaxYear} ticket={ticket} />
            <div className='doxe-footer'>                
            </div>
        </div>
    )
}

DoxExplorerMainTaxYears.propTypes = {
    ticket: PropTypes.object.isRequired,
    onSetTaxYear: PropTypes.func.isRequired,
    layoutType: PropTypes.string.isRequired
}   

export default DoxExplorerMainTaxYears;